import React from 'react';

import AutoInvestment from '@/modules/investments/AutoInvestment';

const AutoInvestmentsPage = () => (
  <AutoInvestment />
);

export default AutoInvestmentsPage;
